module.exports = {
    title: "Student Skills",
    table: {
        skill: "Skill",
    },
}
